export const GROUP_AND_ASSIGN_QUERY_PARAM = 'openIdentifyLearningGaps'
export const GROUP_AND_ASSIGN_STANDARD_QUERY_PARAM = 'interventionStandardId'
// Grouping types
export const GROUPING_TYPES = {
  BY_CATEGORIES: 'BY_CATEGORIES',
  BY_STANDARDS_MASTERY: 'BY_STANDARDS_MASTERY',
  BY_TEST_PERFORMANCE: 'BY_TEST_PERFORMANCE',
}

// Uniform table columns - all grouping types use the same structure
// Only Student Name and Test Score columns
export const STUDENT_TABLE_COLUMNS = [
  {
    key: 'name',
    title: 'Student name',
    dataIndex: 'name',
    render: (text) => text || '-',
  },
  {
    key: 'score',
    title: 'Test score',
    dataIndex: 'score',
    render: (score, record) => {
      const { maxScore = 1 } = record
      return `${score} of ${maxScore}`
    },
  },
]

// Get columns based on grouping type (all return the same columns now)
export const getColumnsByGroupingType = () => {
  return STUDENT_TABLE_COLUMNS
}

// Modal titles based on grouping type
export const getModalTitle = (groupingType) => {
  switch (groupingType) {
    case GROUPING_TYPES.BY_CATEGORIES:
      return 'Identify Learning Gaps'
    case GROUPING_TYPES.BY_STANDARDS_MASTERY:
      return 'Group and Assign by Standards Mastery'
    case GROUPING_TYPES.BY_TEST_PERFORMANCE:
      return 'Group and Assign by Test Performance'
    default:
      return 'Group and Assign'
  }
}

export const FOLLOW_UP_TYPE = {
  PEAR_DECK: 'Pear Deck',
  PEAR_ASSESSMENT_TEST: 'Pear Assessment Test',
}

/** Student names shown before "+N more" in group accordion header (rest in tooltip). */
export const GROUP_AND_ASSIGN_GROUP_HEADER_STUDENT_DISPLAY_MAX = 15

/** Student names shown before "+N more" / expand in subgroup card. */
export const GROUP_AND_ASSIGN_SUBGROUP_STUDENT_DISPLAY_MAX = 10

/** Max ranked deck/test recommendations fetched + shown per standard row. */
export const GROUP_AND_ASSIGN_MAX_RECOMMENDATIONS = 10

/** Recommendation cards shown per carousel page. */
export const GROUP_AND_ASSIGN_RECOMMENDATIONS_PER_PAGE = 2

// TO DO: Fix the constant values
/** ILP drawer content type constants for default product selection by mastery band */
export const ILP_CONTENT_TYPES = {
  PEAR_DECK: 'TYPE_PEAR_DECK',
  PEAR_PRACTICE: 'TYPE_PEAR_PRACTICE_SET',
  PEAR_ASSESSMENT_TEST: 'TYPE_PEAR_ASSESSMENT_TEST',
}

export const DOK_LEVELS = {
  DOK_1_RECALL: 'DOK_1_RECALL',
  DOK_2_SKILL_CONCEPT: 'DOK_2_SKILL_CONCEPT',
  DOK_3_STRATEGIC_THINKING: 'DOK_3_STRATEGIC_THINKING',
  DOK_4_EXTENDED_THINKING: 'DOK_4_EXTENDED_THINKING',
}

export const DIFFICULTY_LEVELS = {
  DIFFICULTY_UNKNOWN: 'DIFFICULTY_UNKNOWN',
  DIFFICULTY_EASY: 'DIFFICULTY_EASY',
  DIFFICULTY_MEDIUM: 'DIFFICULTY_MEDIUM',
  DIFFICULTY_HARD: 'DIFFICULTY_HARD',
}

export const FOLLOW_UP_TYPE_TO_TITLE = {
  [FOLLOW_UP_TYPE.PEAR_DECK]: 'Reteach Lesson',
  [FOLLOW_UP_TYPE.PEAR_ASSESSMENT_TEST]: 'Assign Assessment',
}

export const GROUP_AND_ASSIGN_FEEDBACK_SEGMENT_EVENT =
  'GroupAndAssign:FeedbackSubmit'

export const GROUP_AND_ASSIGN_FEEDBACK_RESPONSE = {
  HELPFUL: 'helpful',
  NOT_HELPFUL: 'not_helpful',
}

export const GROUP_AND_ASSIGN_FEEDBACK_SOURCE = {
  LCB: 'lcb',
  STUDENT_REPORT: 'studentReport',
  CLASS_REPORT: 'classReport',
}
